import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import Hero from '../components/Hero'
import Story from '../components/Story'
import Philosophy from '../components/Philosophy'
import NewCollectionBanner from '../components/NewCollectionBanner'
import WhiteCoutureCollection from '../components/WhiteCoutureCollection'
import WhiteCoutureGallery from '../components/WhiteCoutureGallery'
import PurpleCoutureCollection from '../components/PurpleCoutureCollection'
import JewelleryCoutureCollection from '../components/JewelleryCoutureCollection'
import GoldenZigzag from '../components/GoldenZigzag'
import CoctailDressCollection from '../components/CoctailDressCollection'
import FeaturedCollections from '../components/FeaturedCollections'
import BlackCoutureCollection from '../components/BlackCoutureCollection'
import aaBanner from '../img/Без_названия_800_x_450_пикс_1600_x_200_пикс_1600_x_250_пикс_.png'
import footerLogo from '../img/image_2025-11-23_21-41-25.png'
import ladyInRedVideo from '../imgs/ladyinred.mp4'
import clothingProductionVideo from '../imgs/clothing_1.mp4'
import clothingProductionVideo2 from '../imgs/clothing_2.mp4'
import clothingProductionVideo3 from '../imgs/clothing_3.mp4'
import clothingProductionVideo4 from '../imgs/clothing_4.mp4'
import worldVideo7 from '../img/Видео WhatsApp 2025-11-17 в 12.06.10_05ef68d7.mp4'
import contactVideo from '../img/Видео WhatsApp 2025-11-23 в 21.02.49_985575ef.mp4'
import MediaWithShimmer from '../components/MediaWithShimmer'
import ClickableVideo from '../components/ClickableVideo'
import ExpandableDescription from '../components/ExpandableDescription'
import { useLanguage } from '../contexts/LanguageContext'
import { translations } from '../translations/translations'
import wd20 from '../img/wedding/20.jpg'
import wd30 from '../img/wedding/30.jpg'
import wd1 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.12.08_12268664.jpg'
import wd2 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.13.42_fca963d6.jpg'
import wd3 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.15.59_73f775b7.jpg'
import wd4 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.17.44_0118310f.jpg'
import wd5 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.19.28_63aad1e4.jpg'
import wd6 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.21.55_7ab228fe.jpg'
import wd7 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.23.17_87d6ef11.jpg'
import wd8 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.25.23_1e6cf1fe.jpg'
import wd9 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.27.45_256c1aea.jpg'
import wd10 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.29.07_f20eb9c7.jpg'
import wd11 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.30.29_eb721fd0.jpg'
import wd12 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.32.43_e52345a0.jpg'
import wd13 from '../img/wedding/Изображение WhatsApp 2025-11-25 в 22.33.52_15f792ef.jpg'
import wedding1 from '../imgs/wedding1.jpg'
import wedding2 from '../imgs/wedding2.jpg'
import wedding3 from '../imgs/wedding3.jpg'
import wedding4 from '../imgs/wedding4.jpg'
import wedding5 from '../imgs/wedding5.jpg'
import wedding6 from '../imgs/wedding6.jpg'
import shop from '../imgs/shop.jpg'

import jewel21 from '../imgs/jewellery/photo_21_2026-02-13_23-54-31.jpg'
import jewel27 from '../imgs/jewellery/photo_27_2026-02-13_23-54-31.jpg'
import jewel30 from '../imgs/jewellery/photo_30_2026-02-13_23-54-31.jpg'
import jewel35 from '../imgs/jewellery/photo_35_2026-02-13_23-54-31.jpg'
import jewel38 from '../imgs/jewellery/photo_38_2026-02-13_23-54-31.jpg'
import jewel40 from '../imgs/jewellery/photo_40_2026-02-13_23-54-31.jpg'
import jewel41 from '../imgs/jewellery/photo_41_2026-02-13_23-54-31.jpg'
import jewel49 from '../imgs/jewellery/photo_49_2026-02-13_23-54-18.jpg'
import jewel50 from '../imgs/jewellery/photo_50_2026-02-13_23-54-18.jpg'
import jewel51 from '../imgs/jewellery/photo_51_2026-02-13_23-54-31.jpg'
import jewel53 from '../imgs/jewellery/photo_53_2026-02-13_23-54-18.jpg'
import jewel54 from '../imgs/jewellery/photo_54_2026-02-13_23-54-18.jpg'
import jewel58 from '../imgs/jewellery/photo_58_2026-02-13_23-54-18.jpg'
import jewel59 from '../imgs/jewellery/photo_59_2026-02-13_23-54-18.jpg'
import jewel61 from '../imgs/jewellery/photo_61_2026-02-13_23-54-18.jpg'
import jewel62 from '../imgs/jewellery/photo_62_2026-02-13_23-54-18.jpg'
import jewel63 from '../imgs/jewellery/photo_63_2026-02-13_23-54-18.jpg'
import jewel64 from '../imgs/jewellery/photo_64_2026-02-13_23-54-31.jpg'
import jewel65 from '../imgs/jewellery/photo_65_2026-02-13_23-54-31.jpg'
import jewel66 from '../imgs/jewellery/photo_66_2026-02-13_23-54-31.jpg'
import jewel67 from '../imgs/jewellery/photo_67_2026-02-13_23-54-18.jpg'
import jewel69 from '../imgs/jewellery/photo_69_2026-02-13_23-54-31.jpg'
import jewel70 from '../imgs/jewellery/photo_70_2026-02-13_23-54-31.jpg'
import jewel71 from '../imgs/jewellery/photo_71_2026-02-13_23-54-31.jpg'
import jewel75 from '../imgs/jewellery/photo_75_2026-02-13_23-54-31.jpg'
import jewel76 from '../imgs/jewellery/photo_76_2026-02-13_23-54-31.jpg'
import jewel79 from '../imgs/jewellery/photo_79_2026-02-13_23-54-31.jpg'
import jewelPic1 from '../imgs/jewellery/Picsart_26-02-14_00-09-00-923.png'
import jewelPic2 from '../imgs/jewellery/Picsart_26-02-14_00-11-22-543.png'
import jewelPic3 from '../imgs/jewellery/Picsart_26-02-14_00-11-46-817.png'
import jewelPic5 from '../imgs/jewellery/Picsart_26-02-14_00-12-12-856.png'
import jewelPic6 from '../imgs/jewellery/Picsart_26-02-14_00-12-24-191.png'
import jewelPic10 from '../imgs/jewellery/Picsart_26-02-14_00-20-58-864.png'
import jewelPic11 from '../imgs/jewellery/Picsart_26-02-14_00-22-42-265.png'
import jewelPic12 from '../imgs/jewellery/Picsart_26-02-14_00-25-25-406.png'
import jewelPic21 from '../imgs/jewellery/Picsart_26-02-14_00-57-26-380.png'
import jewelPic23 from '../imgs/jewellery/Picsart_26-02-14_00-58-53-427.png'
import jewelPic29 from '../imgs/jewellery/Picsart_26-02-14_01-02-55-599.png'
import jewelPic38 from '../imgs/jewellery/Picsart_26-02-14_01-51-12-894.png'
import jewelPic39 from '../imgs/jewellery/Picsart_26-02-14_01-52-15-772.jpg'
import jewelPic43 from '../imgs/jewellery/Picsart_26-02-14_01-53-46-745.png'
import jewelPic45 from '../imgs/jewellery/Picsart_26-02-14_01-54-27-209.png'
import jewelPic46 from '../imgs/jewellery/Picsart_26-02-14_01-54-44-746.jpg'
import jewelPic47 from '../imgs/jewellery/Picsart_26-02-14_01-55-05-760.png'
import jewelPic48 from '../imgs/jewellery/Picsart_26-02-14_01-55-25-709.png'
import jewelPic54 from '../imgs/jewellery/Picsart_26-02-14_01-56-39-861.png'
import jewelPic59 from '../imgs/jewellery/Picsart_26-02-14_01-57-46-479.png'
import jewelPic60 from '../imgs/jewellery/Picsart_26-02-14_01-57-57-010.png'
import jewelPic61 from '../imgs/jewellery/Picsart_26-02-14_01-58-07-647.png'
import jewelPic62 from '../imgs/jewellery/Picsart_26-02-14_01-58-19-270.png'
import jewelPic66 from '../imgs/jewellery/Picsart_26-02-14_01-59-42-068.png'

import jewel17_1 from '../imgs/jewellery/photo_2026-02-13_17-46-01.jpg'
import jewel17_2 from '../imgs/jewellery/photo_2026-02-13_17-46-01 (2).jpg'
import jewel17_4 from '../imgs/jewellery/photo_2026-02-13_17-46-01 (4).jpg'
import jewel17_5 from '../imgs/jewellery/photo_2026-02-13_17-46-01 (5).jpg'
import jewel17_6 from '../imgs/jewellery/photo_2026-02-13_17-46-01 (6).jpg'
import jewel17_7 from '../imgs/jewellery/photo_2026-02-13_17-46-01 (7).jpg'
import jewel45_1 from '../imgs/jewellery/photo_2026-02-13_17-45-38.jpg'
import jewel45_2 from '../imgs/jewellery/photo_2026-02-13_17-45-38 (2).jpg'
import jewel45_3 from '../imgs/jewellery/photo_2026-02-13_17-45-38 (3).jpg'

// Jewellery images - only existing files

// Additional jewellery images

// Angelina Alriche Collection images

// Aliens from Mars Collection images

const Home = () => {
  const { language } = useLanguage()
  const tLady = translations.ladyInRed

  const newCollectionImages = [
    '/new_collection/photo_090.webp',
    '/new_collection/WhatsApp%20Image%202026-06-02%20at%2014.12.02.jpeg',
    '/new_collection/WhatsApp%20Image%202026-06-02%20at%2002.43.05.jpeg',
    '/new_collection/WhatsApp%20Image%202026-06-02%20at%2002.42.29.jpeg',
    '/new_collection/WhatsApp%20Image%202026-06-02%20at%2002.41.48.jpeg',
    '/new_collection/photo_006.webp',
    '/new_collection/photo_011.webp',
    '/new_collection/photo_012.webp',
    '/new_collection/photo_021.webp',
    '/new_collection/photo_022.webp',
    '/new_collection/photo_027.webp',
    '/new_collection/photo_033.webp',
    '/new_collection/photo_040.webp',
    '/new_collection/photo_041.webp',
    '/new_collection/photo_046.webp',
    '/new_collection/photo_047.webp',
    '/new_collection/photo_050.webp',
    '/new_collection/photo_051.webp',
    '/new_collection/photo_054.webp',
    '/new_collection/photo_055.webp',
    '/new_collection/photo_056.webp',
    '/new_collection/photo_057.webp',
    '/new_collection/photo_058.webp',
    '/new_collection/photo_059.webp',
    '/new_collection/photo_061.webp',
    '/new_collection/photo_062.webp',
    '/new_collection/photo_063.webp',
    '/new_collection/photo_070.webp',
    '/new_collection/photo_071.webp',
    '/new_collection/photo_072.webp',
    '/new_collection/photo_073.webp',
    '/new_collection/photo_078.webp',
    '/new_collection/photo_079.webp',
    '/new_collection/photo_080.webp',
    '/new_collection/photo_082.webp',
    '/new_collection/photo_083.webp',
    '/new_collection/photo_085.webp',
    '/new_collection/photo_091.webp',
    '/new_collection/photo_094.webp',
    '/new_collection/photo_098.webp',
    '/new_collection/photo_099.webp',
    '/new_collection/photo_102.webp',
    '/new_collection/photo_103.webp'
  ]

  const aboutHouseText = language === 'ru' ? (
    <>
      В мире модного дома ALRICHE элегантность встречается с безграничным творчеством. Наши коллекции воплощают изысканное разнообразие — от безупречно сшитых деловых костюмов до изысканных вечерних платьев, а также обширную и тщательно продуманную детскую линию.<br />
      В настоящее время мы расширяем нашу творческую вселенную разработкой эксклюзивной линии эффектных шляп.<br />
      Для этой новой главы наш дизайнер задумал нечто поистине экстраординарное — концептуальную коллекцию, вдохновленную потусторонней эстетикой, напоминающей о загадочных существах с планеты Марс. Скульптурные силуэты, авангардные головные уборы и поразительные маски переопределяют границы моды, превращая каждый образ в произведение носимого искусства.<br />
      Хотя наш дом уже известен своим богатым выбором вечерней моды и изысканных ансамблей для современной деловой женщины, эта новая коллекция знаменует собой смелый уход в сторону художественных инноваций — предлагая дизайны, которые беспрецедентны и которые невозможно найти больше нигде.<br />
      Мы приглашаем вас ознакомиться с нашими текущими коллекциями на нашем сайте. Пожалуйста, обратите внимание, что эта предстоящая коллекция остается в процессе создания и будет представлена в ближайшее время как воплощение видения, артистизма и бесстрашной индивидуальности.
    </>
  ) : (
    <>
      In the world of ALRICHE Fashion House, elegance meets limitless creativity. Our collections embody a refined diversity — from impeccably tailored business suits to exquisite evening gowns, as well as an extensive and thoughtfully curated children’s line. <br />
      At present, we are expanding our creative universe with the development of an exclusive line of statement hats.<br />
      For this new chapter, our designer has envisioned something truly extraordinary — a conceptual collection inspired by an otherworldly aesthetic, reminiscent of enigmatic beings from the planet Mars. Sculptural silhouettes, avant-garde headpieces, and striking masks redefine the boundaries of fashion, transforming each look into a piece of wearable art.<br />
      While our house is already renowned for its rich selection of evening couture and sophisticated ensembles for the modern businesswoman, this new collection marks a bold departure into artistic innovation — offering designs that are unparalleled and found nowhere else.<br />
      We invite you to explore our current collections on our website. Please note that this upcoming collection remains in creation and will be unveiled soon as a statement of vision, artistry, and fearless individuality.
    </>
  )
  useEffect(() => {
    const el = document.getElementById('home-spacer')
    if (el) el.style.display = 'block'
  }, [])
  useEffect(() => {
    if (typeof window === 'undefined') return

    let isWeddingActive = false
    let isClothingActive = false

    const sectionIds = [
      'hero',
      'world',
      'exclusive-collection',
      'wedding-dresses',
      'clothing-production',
      'luxury-fabrics',
      'red-collection',
      'luxury-handmaker',
      'black-and-white-collection',
      'collection-for-sale',
      'lady-in-red',
      'white-couture',
      'purple-couture',
      'black-Suits',
      'white-collection-gallery',
      'jewellery-collection',
      'jewellery-collection',
      'project-jewellery-shop',
      'jewellery-couture',
      'cocktail',
      'about',
      'world-end'
    ]

    const handleVisibleSection = (id) => {
      window.dispatchEvent(
        new CustomEvent('section:change', {
          detail: { id }
        })
      )
    }

    // Main observer for all sections
    const observer = new IntersectionObserver(
      (entries) => {
        const visibleEntries = entries.filter((entry) => entry.isIntersecting)
        
        // Debug log for luxury-handmaker
        const luxuryEntry = entries.find(e => e.target?.id === 'luxury-handmaker')
        if (luxuryEntry) {
          console.log('luxury-handmaker visibility:', {isIntersecting: luxuryEntry.isIntersecting, ratio: luxuryEntry.intersectionRatio})
        }

        if (!visibleEntries.length) return

        // If the 'about' section is visible at all, always prioritize it
        const aboutEntry = visibleEntries.find((entry) => entry.target?.id === 'about')
        if (aboutEntry) {
          handleVisibleSection('about')
          return
        }

        // First, if the Luxury Fabrics section is visible at all,
        // prioritize it so that the header reliably shows its title
        // while any part of this block is on screen.
        const luxuryFabricsVisible = visibleEntries.find(
          (entry) => entry.target?.id === 'luxury-fabrics'
        )
        if (luxuryFabricsVisible) {
          handleVisibleSection('luxury-fabrics')
          return
        }

        // If the clothing-production section is active from its
        // dedicated observer, keep it active while in view and
        // give it priority over other sections.
        if (isClothingActive) {
          handleVisibleSection('clothing-production')
          return
        }

        // If Wedding Dresses section itself is visible, give it priority
        // over other remaining sections (кроме clothing-production, который выше).
        const weddingEntry = visibleEntries.find((entry) => entry.target?.id === 'wedding-dresses')
        if (weddingEntry) {
          handleVisibleSection('wedding-dresses')
          return
        }

        // If the 'jewellery-collection' section is visible at all, prioritize it
        // so that the header reliably shows its title while this block is on screen.
        const jewelleryEntry = visibleEntries.find((entry) => entry.target?.id === 'jewellery-collection')
        if (jewelleryEntry) {
          console.log('Jewellery collection is visible, setting active section')
          handleVisibleSection('jewellery-collection')
          return
        }

        // If White Couture section is visible at all, prioritize it over
        // overlapping neighboring sections, so that White Suits стабильно
        // отображается, пока блок белых костюмов в зоне видимости.
        const whiteEntry = visibleEntries.find((entry) => entry.target?.id === 'white-couture')
        if (whiteEntry) {
          handleVisibleSection('white-couture')
          return
        }

        // If Black Suits section is visible, give it priority over
        // overlapping neighboring collections (including Purple), so that
        // Black Suits стабильно отображается, пока блок в зоне видимости.
        const blackSuitsEntry = visibleEntries.find((entry) => entry.target?.id === 'black-Suits')
        if (blackSuitsEntry) {
          handleVisibleSection('black-Suits')
          return
        }

        // If Purple Couture section is visible, show it before Cocktail dresses
        // when фиолетовая коллекция в зоне видимости.
        const purpleEntry = visibleEntries.find((entry) => entry.target?.id === 'purple-couture')
        if (purpleEntry) {
          handleVisibleSection('purple-couture')
          return
        }

        // If the 'cocktail' section is visible at all, prioritize it over
        // overlapping collection sections (e.g. white couture).
        const cocktailEntry = visibleEntries.find((entry) => entry.target?.id === 'cocktail')
        if (cocktailEntry) {
          handleVisibleSection('cocktail')
          return
        }

        // Explicitly prioritize the Luxury Handmaker collection when it is visible,
        // so that on mobile the header reliably shows its title while this block
        // is on screen, even if neighboring collections overlap.
        const luxuryVisible = visibleEntries.find((entry) => entry.target?.id === 'luxury-handmaker')
        if (luxuryVisible) {
          handleVisibleSection('luxury-handmaker')
          return
        }

        // For all other sections, pick the one whose top is closest to the
        // viewport center. This makes the section visually centered on screen
        // drive the header title, which helps when sections overlap in view
        // (e.g. White vs Purple collections).
        const viewportCenter = (window.innerHeight || document.documentElement.clientHeight) / 2
        visibleEntries.sort((a, b) => {
          const aDist = Math.abs(a.boundingClientRect.top - viewportCenter)
          const bDist = Math.abs(b.boundingClientRect.top - viewportCenter)
          return aDist - bDist
        })
        const active = visibleEntries[0]
        if (active?.target?.id) {
          handleVisibleSection(active.target.id)
        }
      },
      {
        root: null,
        // Немного меньший threshold, чтобы секции раньше считались видимыми,
        // особенно на мобильных с небольшим экраном.
        threshold: 0.1,
        // Менее агрессивный отрицательный bottom-margin, чтобы центр окна
        // мог "зацепить" средние секции (коллекции и Luxury Fabrics).
        rootMargin: '0px 0px -40% 0px'
      }
    )

    sectionIds.forEach((id) => {
      const el = document.getElementById(id)
      if (el) {
        if (id === 'luxury-handmaker') {
          console.log('Observing #luxury-handmaker element:', el)
        }
        observer.observe(el)
      }
    })

    // Fallback for some mobile browsers where IntersectionObserver can
    // behave inconsistently: manually check the Luxury Handmaker block
    // position on scroll and force it as active while it's prominently
    // in view.
    const handleScrollFallback = () => {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight

      // 1) Luxury Handmaker fallback (высокий приоритет, особенно на мобильных)
      const luxuryEl = document.getElementById('luxury-handmaker')
      if (luxuryEl) {
        const rect = luxuryEl.getBoundingClientRect()
        const luxuryTopVisible = rect.top >= 0 && rect.top <= viewportHeight * 0.5
        if (luxuryTopVisible) {
          handleVisibleSection('luxury-handmaker')
          return
        }
      }

      // 2) Wedding Dresses fallback: если шапка секции в верхней половине экрана,
      // фиксируем её как активную, чтобы на мобилках заголовок не терялся.
      const weddingElFallback = document.getElementById('wedding-dresses')
      if (weddingElFallback) {
        const rect = weddingElFallback.getBoundingClientRect()
        const weddingTopVisible = rect.top >= 0 && rect.top <= viewportHeight * 0.5
        if (weddingTopVisible) {
          handleVisibleSection('wedding-dresses')
          return
        }
      }

      // 2.5) Jewellery Collection fallback: если любая часть секции видна,
      // фиксируем её как активную
      const jewelleryElFallback = document.getElementById('jewellery-collection')
      if (jewelleryElFallback) {
        const rect = jewelleryElFallback.getBoundingClientRect()
        const jewelleryVisible = rect.bottom > 0 && rect.top < viewportHeight
        if (jewelleryVisible) {
          handleVisibleSection('jewellery-collection')
          return
        }
      }

      // 3) White Collection fallback: как только любая часть секции
      // "white-couture" попадает во вьюпорт, фиксируем её как активную,
      // чтобы White Suits не "терялись" при скролле вверх/вниз и не
      // перебивались соседними коллекциями (Purple / Cocktail).
      const whiteSectionEl = document.getElementById('white-couture')
      if (whiteSectionEl) {
        const rect = whiteSectionEl.getBoundingClientRect()
        const isVisible = rect.bottom > 0 && rect.top < viewportHeight
        if (isVisible) {
          handleVisibleSection('white-couture')
          return
        }
      }

      // 4) Purple Suits fallback: если фиолетовая секция в кадре,
      // даём приоритет ей над Black и Cocktail (но после White).
      const purpleElFallback = document.getElementById('purple-couture')
      if (purpleElFallback) {
        const rect = purpleElFallback.getBoundingClientRect()
        const purpleVisible = rect.bottom > 0 && rect.top < viewportHeight
        if (purpleVisible) {
          handleVisibleSection('purple-couture')
          return
        }
      }

      // 5) Black Suits fallback: считаем секцию активной,
      // пока любая часть блока "black-Suits" видна в окне,
      // чтобы весь блок (заголовок + галерея + текст) держал заголовок.
      const blackSuitsEl = document.getElementById('black-Suits')
      if (blackSuitsEl) {
        const rect = blackSuitsEl.getBoundingClientRect()
        const isVisible = rect.bottom > 0 && rect.top < viewportHeight
        if (isVisible) {
          handleVisibleSection('black-Suits')
          return
        }
      }

      // 6) Cocktail dresses fallback: как только любая часть секции
      // "cocktail" попадает во вьюпорт, фиксируем её как активную.
      const cocktailEl = document.getElementById('cocktail')
      if (cocktailEl) {
        const rect = cocktailEl.getBoundingClientRect()
        const isVisible = rect.bottom > 0 && rect.top < viewportHeight
        if (isVisible) {
          handleVisibleSection('cocktail')
          return
        }
      }
    }

    window.addEventListener('scroll', handleScrollFallback, { passive: true })

    // Extra robust observer specifically for the 'about' section, so that
    // when the History block is on screen, the header always shows its title.
    const aboutEl = document.getElementById('about')
    let aboutObserver
    if (aboutEl) {
      aboutObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              handleVisibleSection('about')
            }
          })
        },
        {
          root: null,
          threshold: 0.1,
          rootMargin: '0px 0px -20% 0px'
        }
      )
      aboutObserver.observe(aboutEl)
    }

    // Dedicated observer for the Wedding Dresses section to make sure
    // the header picks it up reliably when this block is on screen.
    const weddingEl = document.getElementById('wedding-dresses')
    let weddingObserver
    if (weddingEl) {
      weddingObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              // Do not override Clothing if it is already active.
              if (!isClothingActive) {
                isWeddingActive = true
                handleVisibleSection('wedding-dresses')
              } else {
                isWeddingActive = false
              }
            } else if (!entry.isIntersecting && entry.target?.id === 'wedding-dresses') {
              isWeddingActive = false
            }
          })
        },
        {
          root: null,
          threshold: 0.05,
          rootMargin: '0px 0px -10% 0px'
        }
      )
      weddingObserver.observe(weddingEl)
    }

    // Dedicated observer for the Clothing production section so that
    // its title is shown reliably when this block is on screen.
    const clothingEl = document.getElementById('clothing-production')
    let clothingObserver
    if (clothingEl) {
      clothingObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            // Считаем секцию активной, пока она вообще видна в вьюпорте.
            if (entry.isIntersecting) {
              isClothingActive = true
              handleVisibleSection('clothing-production')
            } else if (entry.target?.id === 'clothing-production') {
              // Как только секция полностью выходит из кадра, отпускаем флаг.
              isClothingActive = false
            }
          })
        },
        {
          root: null,
          threshold: 0.15,
          rootMargin: '0px 0px -20% 0px'
        }
      )
      clothingObserver.observe(clothingEl)
    }

    // Dedicated observer for the Purple Suits section so that its
    // title is shown reliably when this block is on screen.
    const purpleEl = document.getElementById('purple-couture')
    let purpleObserver
    if (purpleEl) {
      purpleObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              handleVisibleSection('purple-couture')
            }
          })
        },
        {
          root: null,
          // Чуть более строгий порог, чтобы Purple не "держала" заголовок,
          // когда уже в зоне видимости Black Suits.
          threshold: 0.25,
          rootMargin: '0px 0px -15% 0px'
        }
      )
      purpleObserver.observe(purpleEl)
    }

    // Dedicated observer for the Black Suits section so that its
    // title is shown reliably when this block is on screen.
    const blackSuitsElObserver = document.getElementById('black-Suits')
    let blackSuitsObserver
    if (blackSuitsElObserver) {
      blackSuitsObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              handleVisibleSection('black-Suits')
            }
          })
        },
        {
          root: null,
          // Более "агрессивные" настройки: Black Suits считается активным
          // чуть раньше и дольше, чтобы не мигать с Purple.
          threshold: 0.15,
          rootMargin: '0px 0px -10% 0px'
        }
      )
      blackSuitsObserver.observe(blackSuitsElObserver)
    }

    // Dedicated observer for the Cocktail dresses section so that
    // its title is shown reliably when this block is on screen.
    const cocktailEl = document.getElementById('cocktail')
    let cocktailObserver
    if (cocktailEl) {
      cocktailObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              handleVisibleSection('cocktail')
            }
          })
        },
        {
          root: null,
          threshold: 0.15,
          rootMargin: '0px 0px -20% 0px'
        }
      )
      cocktailObserver.observe(cocktailEl)
    }

    // Dedicated observer for the Jewellery Collection section so that
    // its title is shown reliably when this block is on screen.
    const jewelleryEl = document.getElementById('jewellery-collection')
    let jewelleryObserver
    if (jewelleryEl) {
      jewelleryObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              handleVisibleSection('jewellery-collection')
            }
          })
        },
        {
          root: null,
          threshold: 0.15,
          rootMargin: '0px 0px -20% 0px'
        }
      )
      jewelleryObserver.observe(jewelleryEl)
    }

    // Romantic White Collection секция удалена, отдельный observer не нужен.

    if (window.pageYOffset < 50) {
      handleVisibleSection('hero')
    }

    return () => {
      observer.disconnect()
      if (aboutObserver) aboutObserver.disconnect()
      if (weddingObserver) weddingObserver.disconnect()
      if (clothingObserver) clothingObserver.disconnect()
      if (purpleObserver) purpleObserver.disconnect()
      if (blackSuitsObserver) blackSuitsObserver.disconnect()
      if (cocktailObserver) cocktailObserver.disconnect()
      if (jewelleryObserver) jewelleryObserver.disconnect()
      window.removeEventListener('scroll', handleScrollFallback)
    }
  }, [])
  return (
    <div className="overflow-x-hidden site-readable">
      <div id="home-spacer" style={{ height: '10rem', display: 'block' }}>&nbsp;</div>
      <Hero />
      <GoldenZigzag />
      <section id="exclusive-collection" className="bg-[#F9F8F4]">
        {/* ── PRESENTATION TITLE ── */}
        <div className="bg-[#F9F8F4] px-6 md:px-12 lg:px-16 py-12 md:py-16 text-center border-b border-black/10">
          <h2 className="presentation-title playfair font-bold text-gray-900 leading-tight">
            ANGELINA&nbsp;&nbsp;ALRICHE<br />
            International Designer<br />
            Presentation FASHION SHOW<br />
            in Cannes 2026 May. 21<span className="hidden lg:inline">&nbsp;</span><br className="lg:hidden" />"ALIENS from the Planet MARS"
          </h2>
        </div>

        {/* ── P2(2) THE DESIGNER — black page, photo LEFT / text RIGHT ── */}
        <div className="grid md:grid-cols-2 bg-[#080707]">
          <div>
            <MediaWithShimmer
              src="/assets/WhatsApp%20Image%202026-09-01%20at%2013.32.41.jpeg"
              alt={language === 'ru' ? 'Владелица ALRICHE в Дубае' : 'ALRICHE owner in Dubai'}
              className="w-full h-auto object-contain"
            />
          </div>
          <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20 flex flex-col justify-center">
            <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
              {language === 'ru' ? 'Дизайнер' : 'The Designer'}
            </p>
            <h3 className="playfair font-bold text-white text-3xl md:text-4xl lg:text-5xl mt-4">
              ANGELINA  ALRICHE
            </h3>
            <p className="text-white/75 montserrat text-xs md:text-sm mt-5 leading-relaxed">
              {language === 'ru'
                ? 'Основательница ALRICHE • Инженер • Технолог • Конструктор • Международный модельер'
                : 'Founder of ALRICHE • Engineer • Technologist • Pattern Designer • International Fashion Designer'}
            </p>
            <div className="w-full max-w-md h-px bg-[#CEA15F]/70 my-7" />
            <DesignerText language={language} />
            <p className="text-[#CEA15F] font-bold montserrat text-[10px] tracking-[0.25em] uppercase mt-8">
              {language === 'ru' ? 'Последний показ' : 'Latest Show'}
            </p>
            <p className="text-white/80 montserrat text-xs md:text-sm mt-2">
              {language === 'ru'
                ? 'Канны, Франция — во время всемирно известного кинофестиваля'
                : 'Cannes, France — during the world-renowned film festival'}
            </p>
          </div>
        </div>

        <section id="tienda" className="bg-white px-6 md:px-12 lg:px-16 pt-16 md:pt-24 pb-8 md:pb-12 border-y border-gray-200">
          <div className="max-w-7xl mx-auto">
            <div className="max-w-3xl">
              <p className="text-[#CEA15F] font-bold tracking-[0.22em] text-xs md:text-sm uppercase montserrat">
                {language === 'ru' ? 'Барселона · 2026' : 'Barcelona · 2026'}
              </p>
              <h2 className="text-gray-900 font-bold playfair text-3xl md:text-5xl leading-tight mt-4">
                {language === 'ru'
                  ? 'ANGELINА  ALRICHЕ'
                  : 'ANGELINА  ALRICHЕ'}
              </h2>
              <p className="text-black font-bold tracking-[0.22em] text-xs md:text-sm uppercase montserrat mt-6">
                {language === 'ru' ? 'Что делает сейчас' : 'Is doing now'}
              </p>
              <details className="group mt-3">
                <summary className="inline-flex cursor-pointer list-none items-center gap-3 text-[#916321] montserrat text-sm md:text-base font-bold uppercase tracking-[0.14em]">
                  <span>{language === 'ru' ? 'Подробнее' : 'More information'}</span>
                  <span aria-hidden="true" className="text-lg transition-transform duration-200 group-open:rotate-90">→</span>
                </summary>
                <p className="text-gray-800 montserrat font-medium text-base md:text-lg leading-relaxed mt-5">
                  {language === 'ru'
                    ? 'Она делает реконструкцию магазина в Барселоне и готовит новую коллекцию одежды, парфюмерии, сумок.'
                    : 'Angelina Alriche is renovating her store in Barcelona and preparing a new collection of clothing, perfumes, and handbags.'}
                </p>
              </details>
            </div>
          </div>
        </section>

        {/* ── CANNES DUAL VIDEO — two films side by side ── */}
        <div className="grid md:grid-cols-2 bg-[#080707] border-t border-white/10 gap-px">
          <div className="bg-black overflow-hidden">
            <ClickableVideo
              src="/cannas/WhatsApp%20Video%202026-09-02%20at%2016.11.17.mp4"
              className="w-full h-[520px] md:h-[760px] lg:h-[900px] object-contain bg-black"
            />
          </div>
          <div className="bg-black overflow-hidden">
            <ClickableVideo
              src="/cannas/WhatsApp%20Video%202026-09-02%20at%2016.07.16.mp4"
              className="w-full h-[520px] md:h-[760px] lg:h-[900px] object-contain bg-black"
            />
          </div>
        </div>

        <div className="grid md:grid-cols-2 bg-[#11100f] border-t border-white/10">
          <div className="order-2 md:order-1 px-6 md:px-12 lg:px-16 pt-[5px] pb-12 md:pt-16 md:pb-16 flex flex-col justify-center">
            <h4 className="playfair font-bold text-[#CEA15F] text-2xl md:text-3xl lg:text-4xl leading-snug">
              {language === 'ru'
                ? 'С Анжелиной Алричи, международным дизайнером. Эксклюзивное интервью с английским журналистом Мартином'
                : <>Angelina Alriche<br className="hidden md:block" /> International Designer -<br className="hidden md:block" /> An Exclusive Interview<br className="hidden md:block" /> with British<br className="hidden md:block" /> Journalist Martin<br /></>}
            </h4>
            <div className="w-24 h-px bg-[#CEA15F]/70 my-7" />
            <div className="text-white/70 montserrat text-sm md:text-base leading-relaxed max-w-xl space-y-4">
              <p>
                {language === 'ru'
                  ? 'Мартин, журналист из Лондона, взял интервью у международного дизайнера Анжелины Алричи после модного показа коллекции «Пришельцы с планеты Марс», который состоялся в Каннах, Франция, и был приурочен к Каннскому фестивалю 21 мая 2026 года.'
                  : 'Martin, a journalist from London, interviewed international designer Angelina Alriche after the fashion show of the collection "Aliens from the Planet Mars," which took place in Cannes, France, timed to the Cannes Festival on May 21, 2026.'}
              </p>
              <p>
                {language === 'ru' ? 'Это была захватывающая беседа.' : 'It was a fascinating conversation.'}
              </p>
              <p>
                {language === 'ru'
                  ? 'Коллекция посвящена пришельцам и фантастической планете Марс — миру, который давно будоражит воображение Илона Маска.'
                  : 'The collection was dedicated to aliens and the fantastic planet Mars — a world that has long stirred the imagination of Elon Musk.'}
              </p>
              <p>
                {language === 'ru'
                  ? 'В коллекции использовались роскошные и инновационные материалы: пластик, украшенный кристаллами Swarovski, шёлк, кожа, трикотаж со специальным покрытием, маски со встроенной микроподсветкой, а также хамелеон-краски, меняющие цвет.'
                  : 'The collection used luxurious and innovative materials: plastic decorated with Swarovski crystals, silk, leather, knitwear with a special coating, masks with built-in micro-backlighting, as well as chameleon paints that change color.'}
              </p>
              <p>
                {language === 'ru'
                  ? 'Для обогащения и украшения коллекции было использовано множество кристаллов Swarovski. Дизайнер Анжелина Алричи выстроила показ вокруг темы инопланетной жизни, соединив моду со специально созданными музыкальными и визуальными эффектами, которые погрузили зрителей в загадочную атмосферу Марса.'
                  : 'To enrich and decorate the collection, many Swarovski crystals were used. Designer Angelina Alriche built the show around the theme of alien life, combining fashion with specially created musical and visual effects that immersed the audience in the mysterious atmosphere of Mars.'}
              </p>
              <p>
                {language === 'ru'
                  ? 'Необыкновенный синтез моды, музыки, искусства и визуальных эффектов, перенёсший таинственный дух Марса на подиум в Каннах, Франция.'
                  : 'An extraordinary synthesis of fashion, music, art, and visual effects, which transferred the mysterious spirit of Mars to the runway in Cannes, France.'}
              </p>
            </div>
            {/* ОГРОМНЫЙ ТЕКСТ — ВРЕМЕННО СКРЫТО. Блок полностью удалён из DOM; восстановление возможно из git history. */}
          </div>
          <div className="order-1 md:order-2 px-6 md:px-12 lg:px-16 py-12 md:py-16 flex items-start">
            <div className="relative w-full aspect-video bg-black md:sticky md:top-24">
              <iframe
                className="absolute inset-0 w-full h-full"
                src="https://www.youtube-nocookie.com/embed/N4ZEoySmNEk?rel=0"
                title={language === 'ru' ? 'Интервью Мартина с ANGELINA  ALRICHE после Fashion Show' : 'Martin’s interview with ANGELINA  ALRICHE after the Fashion Show'}
                loading="lazy"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              />
            </div>
          </div>
        </div>

        {/* ── P2 THE HOUSE — white page, text ── */}
        <div>
          <div className="px-6 md:px-12 lg:px-16 py-14 md:py-20 flex flex-col justify-center md:text-center md:items-center">
            <p className="text-gray-700 font-bold tracking-[0.22em] text-xs md:text-sm uppercase montserrat">
              {language === 'ru' ? 'Модный дом' : 'The House'}
            </p>
            <h3 className="text-gray-900 font-bold montserrat text-3xl md:text-4xl leading-tight mt-4">
              ANGELINA  ALRICHE
            </h3>
            <p className="text-gray-700 montserrat text-sm md:text-base leading-relaxed mt-6 max-w-lg md:mx-auto">
              {language === 'ru'
                ? 'Анжелина Алричи — международный дизайнер, который создаёт невероятные коллекции одежды и ювелирных изделий для мужчин, женщин и детей.'
                : 'Angelina Alriche is an international designer who creates incredible collections of clothing and jewelry for men, women, and children.'}
            </p>
            <p className="text-gray-700 montserrat font-medium text-sm md:text-base leading-relaxed mt-6 max-w-lg md:mx-auto">
              {language === 'ru'
                ? 'Её последний показ мод состоялся в Каннах, Франция, во время всемирно известного кинофестиваля.'
                : 'Her latest fashion show took place in Cannes, France, during the world-renowned film festival.'}
            </p>
          </div>
        </div>

        {/* ── P4 MATERIALS & DETAIL — white page, text+bullets LEFT / photo RIGHT ── */}
        <div className="grid md:grid-cols-2 bg-[#F9F8F4]">
          <div className="order-2 md:order-1 px-6 md:px-12 lg:px-16 py-14 md:py-20 flex flex-col justify-center">
            <p className="text-gray-700 font-bold tracking-[0.22em] text-xs md:text-sm uppercase montserrat">
              {language === 'ru' ? 'Материалы и детали' : 'Materials & Detail'}
            </p>
            <h3 className="text-gray-900 font-bold montserrat text-3xl md:text-4xl leading-tight mt-4">
              {language === 'ru' ? 'БУДУЩЕЕ СОЗДАНО РУЧНОЙ РАБОТОЙ' : 'THE FUTURE IS HANDCRAFTED'}
            </h3>
            <p className="text-gray-700 montserrat font-medium text-sm md:text-base mt-5">
              {language === 'ru' ? 'В коллекции представлены эксклюзивные материалы:' : 'The collection features exclusive materials:'}
            </p>
            <div className="space-y-2.5 mt-4">
              {[
                language === 'ru' ? '100% натуральный шёлк и плиссированный шёлк' : '100% natural silk & pleated silk',
                language === 'ru' ? 'Экокожа в золотом и серебряном исполнении' : 'Eco-leather in gold and silver finishes',
                language === 'ru' ? 'Сетка, трикотаж и джерси' : 'Mesh, knit fabrics and jersey',
                language === 'ru' ? 'Ручная отделка кристаллами Swarovski' : 'Hand-embellishment with Swarovski crystals',
                language === 'ru' ? 'Люксовая фурнитура золотого и серебряного тона' : 'Luxury gold- and silver-tone hardware',
                language === 'ru' ? 'Головные уборы и маски с микроэлектроникой' : 'Headpieces and masks with microelectronics',
                language === 'ru' ? 'Инновационные покрытия, меняющие цвет' : 'Color-shifting chameleon finishes'
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-3">
                  <span className="text-[#CEA15F] mt-[3px] text-xs leading-none">•</span>
                  <span className="text-base md:text-[17px] text-gray-800 font-medium montserrat leading-relaxed">{item}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="order-1 md:order-2 bg-black flex items-center">
            <MediaWithShimmer
              src="/pdf/aliens/designer-2.jpg"
              alt="Angelina Alriche — designer portrait look"
              className="w-full h-[380px] md:h-[540px] lg:h-[680px] object-cover"
            />
          </div>
        </div>

                {/* ── P6(2) THE RUNWAY — full-bleed photo with overlay, serif heading ── */}
        <div className="relative w-full bg-[#080707] overflow-hidden">
          <MediaWithShimmer
            src="/cannas/WhatsApp%20Image%202026-09-02%20at%2023.26.33.jpeg"
            alt="ALRICHE runway finale in Cannes"
            className="w-full h-[440px] md:h-[560px] lg:h-[640px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/25 to-black/40" />
          <div className="absolute inset-0 flex flex-col justify-between px-6 md:px-12 lg:px-16 py-10 md:py-14">
            <div>
              <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
                {language === 'ru' ? 'Канны • Франция' : 'CANNES • FRANCE'}
              </p>
              <h3 className="playfair font-bold text-white text-4xl md:text-5xl lg:text-6xl mt-4">
                {language === 'ru' ? 'ПОДИУМ' : 'THE RUNWAY'}
              </h3>
            </div>
            <div>
              <p className="text-white/90 montserrat text-sm md:text-base max-w-md leading-relaxed">
                {language === 'ru'
                  ? 'Последний показ мод ALRICHE представил коллекцию на подиуме в Каннах.'
                  : 'The latest ALRICHE fashion show brought the collection to life on the runway in Cannes.'}
              </p>
              <p className="text-[#CEA15F] font-bold montserrat text-[10px] md:text-xs tracking-[0.25em] uppercase mt-4">
                {language === 'ru' ? 'Инопланетяне с планеты Марс' : <>ALIENS FROM THE<span className="hidden sm:inline">&nbsp;</span><br className="sm:hidden" />PLANET MARS</>}
              </p>
            </div>
          </div>
        </div>

        {/* ── CANNES FILM + AD — black page, collection video with music + Cannes ad poster ── */}
        <div className="bg-[#080707] px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            CANNES • FRANCE
          </p>
          <h3 className="playfair font-bold text-white text-3xl md:text-4xl lg:text-5xl mt-4 leading-tight">
            {language === 'ru' ? 'ВИДЕО КОЛЛЕКЦИИ И РЕКЛАМА В КАННАХ' : 'THE COLLECTION FILM & CANNES ADVERTISING'}
          </h3>
          <p className="text-white/60 montserrat text-xs md:text-sm leading-relaxed mt-5 max-w-2xl">
            {language === 'ru'
              ? 'Видео для коллекции было разработано специально — его создал оператор, который сам пишет музыку.'
              : 'The collection film was created specially — shot by a filmmaker who composes his own music.'}
          </p>
          <div className="grid md:grid-cols-[1.5fr_1fr] gap-3 md:gap-4 mt-10">
            <div className="h-[260px] md:h-[560px] overflow-hidden">
              <ClickableVideo
                src="/cannas/WhatsApp%20Video%202026-08-30%20at%2016.28.14.mp4"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="bg-black overflow-hidden flex items-center justify-center">
              <MediaWithShimmer
                src="/cannas/WhatsApp%20Image%202026-08-30%20at%2016.28.15%20(4).jpeg"
                alt={language === 'ru' ? 'Реклама коллекции в Каннах' : 'ALIENS from The Planet MARS — Cannes advertising'}
                className="w-full h-[260px] md:h-[560px] object-contain"
              />
            </div>
          </div>
          <p className="text-[#CEA15F] font-bold montserrat text-[10px] md:text-xs tracking-[0.25em] uppercase mt-8">
            {language === 'ru' ? 'Реклама коллекции в Каннах • ALIENS FROM THE PLANET MARS' : <>CANNES ADVERTISING • ALIENS FROM THE<span className="hidden sm:inline">&nbsp;</span><br className="sm:hidden" />PLANET MARS</>}
          </p>
        </div>

{/* ── P8 SELECTED LOOKS — black page, trio of portraits ── */}
        <div className="bg-[#080707] px-6 md:px-12 lg:px-16 py-14 md:py-20">
          <p className="text-[#CEA15F] font-bold tracking-[0.3em] text-[11px] md:text-xs uppercase montserrat">
            {language === 'ru' ? 'Избранные образы' : 'Selected Looks'}
          </p>
          <h3 className="text-white font-bold montserrat text-3xl md:text-4xl leading-tight mt-4">
            {language === 'ru' ? 'КОСМИЧЕСКИЕ СИЛУЭТЫ' : 'COSMIC SILHOUETTES'}
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 mt-8">
            {[
              { src: '/pdf/aliens/looks-1.jpg', alt: 'Cosmic silhouette look 1' },
              { src: '/assets/WhatsApp%20Image%202026-09-01%20at%2013.30.43.jpeg', alt: language === 'ru' ? 'Модель ALRICHE в Дубае' : 'ALRICHE model in Dubai' },
              { src: '/pdf/aliens/looks-3.jpg', alt: 'Cosmic silhouette look 3' }
            ].map((item, index) => (
              <MediaWithShimmer
                key={index}
                src={item.src}
                alt={item.alt}
                className="w-full aspect-[2/3] object-cover"
              />
            ))}
          </div>
        </div>

        <div className="bg-white px-6 md:px-12 lg:px-16 py-14 md:py-20 text-center border-t border-gray-200">
          <Link to="/alriche-presentation" className="inline-flex min-h-11 items-center justify-center border border-black bg-black px-8 md:px-12 py-4 text-white montserrat text-xs md:text-sm font-semibold tracking-[0.2em] uppercase transition-colors hover:bg-[#CEA15F] hover:border-[#CEA15F]">
            {language === 'ru' ? 'Смотреть больше' : 'You can see more'}<span className="ml-3" aria-hidden="true">→</span>
          </Link>
        </div>
      </section>
      <section className="bg-white px-4 py-10 md:py-14">
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center gap-6 md:gap-10">
          <div className="flex-1">
            <span className="text-[10px] md:text-[11px] tracking-[0.35em] uppercase text-[#CEA15F] montserrat font-medium">
              {language === 'ru' ? 'Интервью' : 'Interview'}
            </span>
            <h2 className="text-2xl md:text-3xl font-light text-gray-900 playfair mt-2">
              ASTAR
            </h2>
            <p className="text-sm md:text-base text-gray-700 leading-relaxed montserrat mt-3">
              {language === 'ru'
                ? 'ASTAR — композитор, певица и поэтесса. Модель бренда ALRICHE.'
                : 'ASTAR is a composer, singer, and poetess. Model for the ALRICHE brand.'}
            </p>
            <p className="text-xs md:text-sm text-gray-500 italic montserrat mt-2">
              {language === 'ru'
                ? 'Интервью с английским журналистом из Лондона, 23 мая 2026 года.'
                : 'Interview with an English journalist from London, May 23, 2026.'}
            </p>
          </div>
          <div className="w-full md:w-[46%]">
            <video
              className="w-full h-auto object-contain"
              controls
              playsInline
              preload="metadata"
              onLoadedMetadata={(e) => { e.target.currentTime = 3 }}
              src="/new_collection/WhatsApp%20Video%202026-06-02%20at%2002.48.45.mp4"
            >
              {language === 'ru' ? 'Ваш браузер не поддерживает воспроизведение видео.' : 'Your browser does not support the video tag.'}
            </video>
          </div>
        </div>
      </section>
      {/* ═══════════════════════════════════════════════════════════════
          ALIENS FROM THE PLANET MARS — PDF-style side-by-side layout
          ═══════════════════════════════════════════════════════════════ */}

      <GoldenZigzag />
      <Philosophy />
      <section id="business-suite" className="bg-white px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-2">
            <p className="text-xl md:text-2xl lg:text-3xl font-normal text-gray-900 tracking-[0.14em] uppercase montserrat">
              {language === 'ru' ? 'Бизнес-костюмы' : 'Business Suits'}
            </p>
          </div>
          <div className="flex flex-col gap-5 md:gap-6 lg:gap-8 max-w-4xl mx-auto text-left md:text-center">
            <p className="text-sm md:text-base lg:text-lg text-gray-800 leading-relaxed montserrat">
              {language === 'ru'
                ? 'Этот костюм разработан дизайнером и технологом ANGELINA  ALRICHE по новой, авторской технологии. Костюмы ALRICHE отличаются от традиционных методов конструирования Chanel. Ключевые отличия заключаются в обработке швов и исключении многих элементов, присутствующих в винтажной технологии Chanel. ANGELINA  ALRICHE разработала эту технологию для современной женщины в движении: она водит машину, ей нужно быстро стирать одежду в машинке, и у неё нет времени на глажку.'
                : 'This suit was developed by designer and technologist ANGELINA  ALRICHE using a new, proprietary technique. ALRICHE suits differ from the traditional Chanel construction methods. The key differences lie in the seam processing and the elimination of many elements found in Chanel\'s vintage technology. ANGELINA  ALRICHE has designed this technology for the modern woman on the go: she drives, needs to machine-wash her clothes quickly, and has no time for ironing.'}
            </p>
            <p className="text-sm md:text-base lg:text-lg text-gray-800 leading-relaxed montserrat">
              {language === 'ru'
                ? 'Эти костюмы можно стирать в машинке, они не садятся и не мнутся. Ткань имеет растяжение на 2 размера, обеспечивая идеальную посадку от размера S до L. Даже при размере XXXL силуэт остаётся элегантным, стройным и очень привлекательным. В этих костюмах каждая женщина превращается в утончённую, высокостатусную бизнес-леди.'
                : 'These suits are machine-washable, shrink-resistant, and wrinkle-free. The fabric features a 2-size stretch, ensuring a perfect fit from size S to L. Even at size XXXL, the silhouette remains elegant, slim, and highly attractive. In these suits, every woman transforms into a sophisticated, high-status business lady.'}
            </p>
            <p className="text-sm md:text-base lg:text-lg text-gray-800 leading-relaxed montserrat">
              {language === 'ru'
                ? 'Состав ткани: Джерси трикотаж (синтетика) в основном состоит из полиэстера (часто с добавлением эластана, лайкры или спандекса), что делает его прочным, износостойким, сохраняющим форму и лёгким в уходе; однако он также может быть в смесях с хлопком или вискозой для повышения комфорта, влагопоглощения и мягкости, сохраняя при этом характеристики синтетического джерси.'
                : 'Fabric composition: Jersey knit (synthetic) primarily consists of polyester (often with added elastane, lycra, or spandex), making it durable, wear-resistant, shape-retentive, and easy to care for; however, it can also come in blends with cotton or viscose to enhance comfort, moisture absorption, and softness while maintaining the characteristics of synthetic jersey.'}
            </p>
            <p className="text-sm md:text-base lg:text-lg text-gray-800 leading-relaxed montserrat">
              {language === 'ru'
                ? 'В стоимость входят три предмета: 1. Брюки, 2. Жилет, 3. Жакет. Ручная работа высочайшего качества, haute couture.'
                : 'The price includes three items: 1. Trousers, 2. Waistcoat, 3. Jacket. Handcrafted to the highest quality, haute couture.'}
            </p>
            <p className="text-sm md:text-base lg:text-lg text-gray-900 leading-relaxed montserrat font-semibold text-center">
              {language === 'ru'
                ? 'Стоимость: €1,500'
                : 'Price: €1,500'}
            </p>
          </div>
        </div>
      </section>
      <section className="bg-white px-4">
        <div className="max-w-7xl mx-auto">
          <div>
            <div className="flex flex-col gap-3 mb-2 mt-2">
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4">
                <span className="flex items-center justify-center">
                  <img
                    src={aaBanner}
                    alt="Angelina Alriche"
                    className="h-12 md:h-14 lg:h-16 object-contain"
                  />
                </span>
                <span
                  id="white-collection-title"
                  className="text-xl md:text-2xl lg:text-3xl uppercase tracking-[0.3em] text-gray-900 mt-1 md:mt-0 md:ml-6 md:ml-8 text-center md:text-left font-extrabold"
                >
                  {language === 'ru' ? 'Белые костюмы' : 'White Suits'}
                </span>
              </div>
            </div>

            <WhiteCoutureCollection />

            <div className="flex flex-col mb-2 mt-2">
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4">
                <span className="flex items-center justify-center">
                  <img
                    src={aaBanner}
                    alt="Angelina Alriche"
                    className="h-12 md:h-14 lg:h-16 object-contain"
                  />
                </span>
                <span className="text-lg md:text-xl lg:text-2xl uppercase tracking-[0.3em] text-gray-900 mt-1 md:mt-0 md:ml-6 md:ml-8 text-center md:text-left font-extrabold">
                  {language === 'ru' ? 'Сиреневые костюмы' : 'Lilac Suits'}
                </span>
              </div>
            </div>

            <div className="mb-2">
              <PurpleCoutureCollection />
            </div>

            <div id="black-Suits">
              <div className="flex flex-col gap-3 mb-2 mt-2">
                <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-4">
                  <span className="flex items-center justify-center">
                    <img
                      src={aaBanner}
                      alt="Angelina Alriche"
                      className="h-12 md:h-14 lg:h-16 object-contain"
                    />
                  </span>
                  <span className="text-xl md:text-2xl lg:text-3xl uppercase tracking-[0.3em] text-gray-900 mt-1 md:mt-0 md:ml-6 md:ml-8 text-center md:text-left font-extrabold">
                    {language === 'ru' ? 'Черные костюмы' : 'Black Suits'}
                  </span>
                </div>
              </div>

              <BlackCoutureCollection />

              <div className="max-w-3xl mx-auto text-center space-y-3">
                <p className="text-sm md:text-base text-gray-700 montserrat">
                  {language === 'ru'
                    ? 'Можно заказывать такие же костюмы в любом цвете: белый, чёрный, красный, синий, зелёный, розовый, жёлтый, сиреневый и другие — все цвета радуги.'
                    : 'You can order the same suits in any color: white, black, red, blue, green, pink, yellow, Purple and many others — all the colors of the rainbow.'}
                </p>
                <p className="text-sm md:text-base text-gray-800 montserrat font-semibold">
                  {language === 'ru'
                    ? 'Любой цвет. Любой размер.'
                    : 'Any color. Any size.'}
                </p>
                <p className="text-sm md:text-base text-gray-700 montserrat">
                  {language === 'ru'
                    ? 'Костюмы выполнены из джерси — это эластичный трикотаж, который мягко тянется и обеспечивает комфортную посадку.'
                    : 'The suits are made from jersey — a stretch knit fabric that gently follows the body and provides a comfortable fit. A full technical description will be added later.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <GoldenZigzag />
      <CoctailDressCollection />
      <GoldenZigzag />
      <FeaturedCollections />
      <GoldenZigzag />
      <section id="wedding-dresses" className="bg-white px-4">
        <div className="max-w-7xl mx-auto">
          <div className="mb-5 text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.15em] uppercase playfair mb-5">
              {language === 'ru' ? 'Свадебные платья' : 'Wedding Dresses'}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {[
              wedding1,
              wedding2,
              wedding3,
              wedding4,
              wedding5,
              wedding6,
              wd20,
              wd1,
              wd2,
              wd3,
              wd4,
              wd5,
              wd6,
              wd7,
              wd8,
              wd9,
              wd10,
              wd11,
              wd12,
              wd13
            ].map(
              (src, index) => (
                <Link to="/shop" key={index} className="group cursor-pointer block">
                  <div className="relative overflow-hidden rounded-3xl border border-[#CEA15F]/40 shadow-[0_0_40px_rgba(206,161,95,0.25)]">
                    <MediaWithShimmer
                      src={src}
                      alt={`Wedding dress ${index + 1}`}
                      className="w-full h-[620px] md:h-[580px] object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-black/15 opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                </Link>
              )
            )}
          </div>
        </div>
      </section>
      <GoldenZigzag />
      <section id="jewellery-collection" className="bg-white px-4 pb-12">
        <div className="max-w-7xl mx-auto mt-8">
          {/* Enamel Collection Header */}
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.15em] uppercase playfair text-gray-900">
              {language === 'ru' ? 'Коллекция с эмалью' : 'Enamel Collection'}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            <div className="block">
              <div className="mb-3 text-center">
                <h3 className="text-lg md:text-xl font-medium text-gray-900 montserrat">
                  {language === 'ru' ? '"Красная Роза"' : '"Red Rose"'}
                </h3>
              </div>
              <Link to="/shop" className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={jewelPic59}
                    alt="Jewellery 1"
                    className="w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white"
                  />
                </div>
              </Link>
              <div className="mt-3 text-center">
                <ExpandableDescription
                  language={language}
                  title={language === 'ru' ? '"Красная Роза"' : '"Red Rose"'}
                  fullText={language === 'ru' 
                    ? 'Кольцо авторской ручной работы.\nБриллианты 3 карата\nРубины 0,9 карат\nЗолото 750°\nЭмаль красная'
                    : 'Handcrafted ring.\nDiamonds 3 carats\nRubies 0.9 carats\n18k Gold\nRed enamel'}
                />
              </div>
            </div>
            <div className="block">
              <div className="mb-3 text-center">
                <h3 className="text-lg md:text-xl font-medium text-gray-900 montserrat">
                  {language === 'ru' ? '"ЯБЛОКО из Рая"' : '"Apple from Paradise"'}
                </h3>
              </div>
              <Link to="/shop" className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={jewel51}
                    alt="Jewellery 2"
                    className="w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white"
                  />
                </div>
              </Link>
              <div className="mt-3 text-center">
                <ExpandableDescription
                  language={language}
                  title={language === 'ru' ? '"ЯБЛОКО из Рая"' : '"Apple from Paradise"'}
                  fullText={language === 'ru' 
                    ? 'Комплект ручной работы, Серьги, подвеска.\nЭмаль - красная\nЗолото 750°\nБриллианты более 0.2 - 3.5 карат'
                    : 'Handcrafted set, Earrings, pendant.\nRed enamel\n18k Gold\nDiamonds over 0.2 - 3.5 carats'}
                />
              </div>
            </div>
            <div className="block">
              <div className="mb-3 text-center">
                <h3 className="text-lg md:text-xl font-medium text-gray-900 montserrat">
                  {language === 'ru' ? 'Галактика' : 'GALAXY'}
                </h3>
              </div>
              <Link to="/shop" className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={jewel75}
                    alt="Jewellery 3"
                    className="w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white"
                  />
                </div>
              </Link>
              <div className="mt-3 text-center">
                <ExpandableDescription
                  language={language}
                  title={language === 'ru' ? 'Галактика' : 'GALAXY'}
                  fullText={language === 'ru' 
                    ? 'Кольцо — ручной работы, в единственном экземпляре.\nСиняя эмаль\n18-каратное золото (750°)\nБриллианты чистотой VVS1\nОбщий вес: 4,5 карата'
                    : 'The ring is a one-of-a-kind, handmade piece.\nBlue enamel\n18K gold (750°)\nVVS1 diamonds\nTotal weight: 4.5 carats'}
                />
              </div>
            </div>
            <div className="block">
              <div className="mb-3 text-center">
                <h3 className="text-lg md:text-xl font-medium text-gray-900 montserrat">
                  {language === 'ru' ? 'ОКО ВСЕЛЕННОЙ' : 'THE EYE OF THE UNIVERSE'}
                </h3>
              </div>
              <Link to="/shop" className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={jewelPic54}
                    alt="Jewellery 4"
                    className="w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white"
                  />
                </div>
              </Link>
              <div className="mt-3 text-center">
                <ExpandableDescription
                  language={language}
                  title={language === 'ru' ? 'ОКО ВСЕЛЕННОЙ' : 'THE EYE OF THE UNIVERSE'}
                  fullText={language === 'ru' 
                    ? `Haute Couture. Единственный экземпляр. Ручная работа.

Шагните в бесконечность с «Оком Вселенной» — экстраординарным творением высокого ювелирного искусства, где небесная тайна встречается с бескомпромиссным мастерством. 

<<Эксклюзивный гарнитур  значение- символ власти, прозрения ,  богатства, изобилие, славы , популярности в вечность>> 

✨ Кулон
Выполнен  из 18-каратного золота (79,8 г), этот величественный кулон излучает космическое сияние.
В его сердце покоится завораживающая бирюза весом 35 карат, воплощающая глубину и мудрость мироздания.

Его сияние подчеркивают:
1,5 карата бриллиантов — чистый свет и вечный огонь;
1,3 карата изумрудов — пульс жизни и обновления;
1,5 карата оранжевых сапфиров — пламя страсти и энергии.

Сложная техника витражной и горячей эмали создает живую, светящуюся поверхность, напоминающую далекие галактики. Роскошные акценты из меха норки добавляют тактильного великолепия, а нить из 100% шелка завершает композицию, придавая ей мягкость и грацию.

✨ Браслет
Мощный спутник кулона, браслет выполнен из 18-каратного золота (92,5 г) — смелый, сияющий, незабываемый.

Он украшен:
1,5 карата бриллиантов;
1,2 карата изумрудов;
1,5 карата оранжевых сапфиров.

Дополненный тем же виртуозным искусством витражной эмали, деталями из меха норки и шелковой нитью, он воплощает гармонию силы и утонченности.

«Око Вселенной» создано для тех, кто осмеливается видеть больше обыденного — для коллекционеров исключительных вещей, для визионеров, для тех, кто носит искусство, а не просто украшения.

Манифест. Талисман. Целая Вселенная, запечатленная в золоте.

<< ГЛАЗ  ВСЕЛЕННОЙ>>
АВТОРСКАЯ РУЧНАЯ РАБОТА ОТ КУТЮР 

ПОДВЕСКА 
ВЕС ЗОЛОТА 18 КАРАТ 79.8 ГР
Бирюза  35 карат
Бриллианты  1.5 карат
Изумруды  1.3 карат
Сапфиры  оранжевые1.5 карат 
Витражная эмаль
Горячая эмаль 
Мех - норка
Нить - шелк 100%

Браслет 
Вес золота  18 карат92.5 гр. 
Бриллианты  1.5 карат
Изумруды  1.2 карат
Сапфиры  оранжевые1.5 карат 
Витражная эмаль
Горячая эмаль 
Мех - норка
Нить - шелк 100%`
                    : `Haute Couture. One of a Kind. Handcrafted Masterpiece.

Step into infinity with "The Eye of the Universe" — an extraordinary haute couture creation where celestial mystery meets uncompromising craftsmanship. This exclusive set is a profound symbol of power, vision, and wealth; an emblem of abundance, glory, and fame that transcends time into eternity.

✨ The Pendant
Forged in 18K gold (79.8 g), this magnificent pendant radiates cosmic brilliance.
At its heart lies a mesmerizing 35-carat turquoise, embodying the depth and wisdom of the universe.

Its radiance is amplified by:
1.5 carats of diamonds — pure light and timeless fire;
1.3 carats of emeralds — the pulse of life and renewal;
1.5 carats of orange sapphires — the flame of passion and energy.

Intricate stained-glass and hot enamel techniques create a vibrant, luminous surface reminiscent of celestial galaxies. Luxurious mink fur accents add tactile opulence, while a 100% silk thread completes the composition with softness and grace.

✨ The Bracelet
A powerful companion to the pendant, the bracelet is crafted in 18K gold (92.5 g) — bold, radiant, and unforgettable.

It is adorned with:
1.5 carats of diamonds;
1.2 carats of emeralds;
1.5 carats of orange sapphires.

Enhanced by the same masterful enamel artistry, mink fur details, and silk thread, it embodies the perfect harmony between strength and refinement.

"The Eye of the Universe" is created for those who dare to see beyond the ordinary — for collectors of the exceptional, for visionaries, and for those who wear art, not simply jewelry.

A statement. A talisman. A universe captured in gold.

THE EYE OF THE UNIVERSE
One-of-a-kind Handmade Couture Piece

PENDANT
18K Gold Weight: 79.8 g
Turquoise: 35 ct
Diamonds: 1.5 ct
Emeralds: 1.3 ct
Orange Sapphires: 1.5 ct
Enamel: Plique-à-jour (vitreous) and Grand Feu enamel
Materials: Mink fur, 100% silk thread

BRACELET
18K Gold Weight: 92.5 g
Diamonds: 1.5 ct
Emeralds: 1.2 ct
Orange Sapphires: 1.5 ct
Enamel: Plique-à-jour (vitreous) and Grand Feu enamel
Materials: Mink fur, 100% silk thread`}
                />
              </div>
            </div>
            <div className="block">
              <div className="mb-3 text-center">
                <h3 className="text-lg md:text-xl font-medium text-gray-900 montserrat">
                  {language === 'ru' ? 'FLASH DESIGN' : 'FLASH DESIGN'}
                </h3>
              </div>
              <Link to="/shop" className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={jewelPic45}
                    alt="Flash Design Ring"
                    className="w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white"
                  />
                </div>
              </Link>
              <div className="mt-3 text-center">
                <ExpandableDescription
                  language={language}
                  title={language === 'ru' ? 'FLASH DESIGN' : 'FLASH DESIGN'}
                  fullText={language === 'ru' 
                    ? `Эксклюзивное дизайнерское кольцо ручной работы изделие вращается вокруг пальца, украшено яркой горячей эмалью, и инкрустировано бриллиантами.

Дизайн состоит из двух соединенных полос с вращающимся центральным диском.

Бриллианты: 3,5 карата, чистота VVS1
18-каратное золото
Вес: 11,5 г`
                    : `This exclusive, handcrafted designer ring rotates around the finger, is adorned with vibrant hot enamel, and is encrusted with diamonds.

The design consists of two connected bands with a rotating central disc.

Diamonds: 3.5 carats, VVS1 clarity
18-karat gold
Weight: 11.5 g`}
                />
              </div>
            </div>
            {/* First 2 items of enamel collection from array */}
            {[
              jewel79, // 1
              jewel38 // 2
            ].map((src, index) => (
              <Link to="/shop" key={index} className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={src}
                    alt={`Jewellery ${index + 6}`}
                    className={`w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white`}
                  />
                </div>
              </Link>
            ))}
          </div>

          {/* Designer Collection Header */}
          <div className="text-center mb-8 mt-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.15em] uppercase playfair text-gray-900">
              {language === 'ru' ? 'Дизайнерская коллекция' : 'Designer Collection'}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {[
              jewel69, // 1 (было 3, было 8) - photo_69
              jewelPic29, // 2 (было 4, было 9) - Picsart_26-02-14_01-02-55-599
              jewel70, // 3 (было 5, было 10) - photo_70
              jewel64, // 4 (было 6, было 11) - photo_64
              jewelPic46, // 5 (было 7, было 12) - Picsart_26-02-14_01-54-44-746
              jewel66, // 6 (было 8, было 13) - photo_66
              jewelPic43, // 7 (было 9, было 14) - Picsart_26-02-14_01-53-46-745
              jewelPic5, // 8 (было 10, было 15) - Picsart_26-02-14_00-12-12-856
              jewel76, // 9 (было 11, было 16) - photo_76
              jewel17_2, // 10 - photo_2026-02-13_17-46-01 (2)
              jewel17_1, // 11 - photo_2026-02-13_17-46-01
              jewel17_4, // 12 - photo_2026-02-13_17-46-01 (4)
              jewel17_5, // 13 - photo_2026-02-13_17-46-01 (5)
              jewel17_6, // 14 - photo_2026-02-13_17-46-01 (6)
              jewel17_7, // 15 - photo_2026-02-13_17-46-01 (7)
              jewel17_7, // 15 - photo_2026-02-13_17-46-01 (7)
              jewel71, // 16 (было 11, было 10, было 17, было 19, было 24) - photo_71
              jewel49, // 17 (было 12, было 11, было 18, было 20) - photo_49 (вместо jewelPic66)
              jewelPic23, // 18 (было 13, было 12, было 19, было 21) - Picsart_26-02-14_00-58-53-427
              jewel65, // 19 (было 14, было 13, было 20, было 22) - photo_65
              jewelPic62, // 20 (было 15, было 14, было 21, было 23) - Picsart_26-02-14_01-58-19-270
              jewelPic60, // 21 (было 16, было 15, было 22, было 24) - Picsart_26-02-14_01-57-57-010
              jewelPic61, // 22 (было 17, было 16, было 23, было 25) - Picsart_26-02-14_01-58-07-647
              jewelPic3, // 23 (было 18, было 17, было 24, было 26) - Picsart_26-02-14_00-11-46-817
              jewelPic39, // 24 (было 19, было 18, было 25, было 27) - Picsart_26-02-14_01-52-15-772
              jewelPic11, // 25 (было 20, было 19, было 26, было 28) - Picsart_26-02-14_00-22-42-265
              jewel41, // 26 (было 21, было 20, было 27, было 29) - photo_41
              jewelPic38, // 22 (было 21, было 28, было 30) - Picsart_26-02-14_01-51-12-894
              jewelPic1, // 23 (было 22, было 29, было 31) - Picsart_26-02-14_00-09-00-923
              jewel40, // 24 (было 23, было 30, было 32) - photo_40
              jewelPic2, // 25 (было 24, было 31, было 33) - Picsart_26-02-14_00-11-22-543
              jewelPic6, // 26 (было 25, было 32, было 34) - Picsart_26-02-14_00-12-24-191
              jewelPic48, // 27 (было 26, было 33, было 35) - Picsart_26-02-14_01-55-25-709 (вместо jewelPic47)
              jewelPic47 // 28 (было 27, было 34, было 36) - Picsart_26-02-14_01-55-05-760
            ].map((src, index) => (
              <Link to="/shop" key={index} className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={src}
                    alt={`Jewellery ${index + 8}`}
                    className={`w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white`}
                  />
                </div>
              </Link>
            ))}
          </div>

          {/* Wedding Rings Header */}
          <div className="text-center mb-8 mt-12">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.15em] uppercase playfair text-gray-900">
              {language === 'ru' ? 'Обручальные кольца' : 'Wedding Rings'}
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {[
              jewelPic12, // 1 (было 35, было 37) - Picsart_26-02-14_00-25-25-406
              jewel67, // 2 (было 36, было 38) - photo_67
              jewelPic10, // 3 (было 37, было 39) - Picsart_26-02-14_00-20-58-864
              jewel35, // 4 (было 38, было 40) - photo_35
              jewelPic21, // 5 (было 39, было 41) - Picsart_26-02-14_00-57-26-380
              jewel63, // 6 (было 40, было 42) - photo_63
              jewel62, // 7 (было 41, было 43) - photo_62
              jewel61, // 8 (было 42, было 44) - photo_61
              jewel30, // 9 (было 43, было 45) - photo_30
              jewel59, // 10 (было 44, было 46) - photo_59
              jewel58, // 11 (было 45, было 47) - photo_58
              jewel27, // 12 (было 46, было 48) - photo_27
              jewel45_3, // 13 (было 47, было 49) - photo_2026-02-13_17-45-38 (3)
              jewel45_1, // 14 (было 48, было 50) - photo_2026-02-13_17-45-38
              jewel54, // 15 (было 49, было 51) - photo_54
              jewel53, // 16 (было 50, было 52) - photo_53
              jewel45_2, // 17 (было 51, было 53) - photo_2026-02-13_17-45-38 (2)
              jewel21, // 18 (было 52, было 54) - photo_21
              jewel50 // 19 (было 53, было 55) - photo_50
            ].map((src, index) => (
              <Link to="/shop" key={index} className="cursor-pointer block">
                <div className="relative overflow-hidden rounded-2xl border border-[#CEA15F]/30 shadow-[0_0_30px_rgba(206,161,95,0.2)]">
                  <MediaWithShimmer
                    src={src}
                    alt={`Wedding Ring ${index + 1}`}
                    className={`w-full h-[280px] sm:h-[320px] md:h-[360px] object-contain bg-white`}
                  />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
      <GoldenZigzag />
      <section id="clothing-production" className="bg-white px-4">
        <div className="max-w-4xl lg:max-w-6xl mx-auto">
          <div className="mb-5 text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.15em] uppercase playfair mb-5">
              {translations.clothingProduction.title[language]}
            </h2>
          </div>

          <div className="relative rounded-[2.5rem] overflow-hidden w-full max-w-md mx-auto h-[500px] md:h-[650px] lg:h-[800px]">
            <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/10 to-transparent pointer-events-none" />
            <ClickableVideo
              src={clothingProductionVideo}
              className="w-full h-full object-cover scale-125 md:scale-105 transition-transform duration-[6000ms] md:hover:scale-110"
            />
          </div>
        </div>
      </section>
      <GoldenZigzag />
      <section id="luxury-fabrics" className="bg-white px-4">
        <div className="max-w-4xl lg:max-w-6xl mx-auto">
          <div className="mb-5 text-center">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.15em] uppercase playfair mb-5">
              {language === 'ru' ? 'Роскошные ткани' : 'Luxury Fabrics'}
            </h2>
            <p className="text-sm md:text-base text-gray-900 max-w-2xl mx-auto montserrat">
              Luxury fabrics are embroidered with various ornaments using beads and Swarovski crystals, hand-made on a mesh for each individual order.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
            {[clothingProductionVideo2, clothingProductionVideo3, clothingProductionVideo4].map((src, index) => (
              <div
                key={index}
                className={
                  `relative rounded-[2.5rem] overflow-hidden w-full ` +
                  (index === 1
                    ? 'h-[300px] md:h-[580px] lg:h-[620px]'
                    : 'h-[520px] md:h-[580px] lg:h-[620px]')
                }
              >
                <div className="absolute inset-0 bg-gradient-to-t from-black/35 via-black/10 to-transparent pointer-events-none" />
                <ClickableVideo
                  src={src}
                  className="w-full h-full object-cover scale-100 bg-black"
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Temporarily hidden Lady in Red section */}
      {false && (
        <>
          <GoldenZigzag />
          <section id="lady-in-red" className="w-full px-0 md:px-4 bg-white text-zinc-900">
            <div className="max-w-6xl mx-auto flex flex-col items-center">
              <div className="text-center">
                <div className="text-3xl md:text-4xl lg:text-5xl font-light mb-5 text-gray-900 playfair tracking-[0.08em] whitespace-nowrap">
                  {tLady.headingTitle[language]}
                </div>
              </div>

              <div className="relative rounded-[2.5rem] overflow-hidden h-[680px] md:h-[620px] lg:h-[720px]">
                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-black/10 to-transparent pointer-events-none" />
                <MediaWithShimmer
                  type="video"
                  src={ladyInRedVideo}
                  muted
                  autoPlay
                  loop
                  playsInline
                  wrapperClassName="flex items-center justify-center h-[680px] md:h-[620px] lg:h-[720px]"
                  className="w-full h-full object-cover scale-100 md:scale-105 transition-transform duration-[6000ms] md:hover:scale-110"
                />
              </div>
            </div>
          </section>
          <GoldenZigzag />
        </>
      )}
      <GoldenZigzag />
      <JewelleryCoutureCollection />
      <GoldenZigzag />
      <Story />
      <GoldenZigzag />
      <section id="world-end" className="bg-white px-4">
        <div className="max-w-6xl mx-auto py-10 pt-0">
          <div className="relative">
            <div className="group relative overflow-hidden w-full h-full rounded-[2.5rem]">
              <ClickableVideo
                src={worldVideo7}
                className="block w-full h-full object-cover object-top scale-105 transition-transform duration-[6000ms] md:group-hover:scale-110"
              />
            </div>
          </div>
        </div>
      </section>
      <section id="contact" className="bg-black text-white px-0 py-5 pt-0 lg:min-h-screen">
        <div className="max-w-[1920px] mx-auto flex flex-col items-center gap-10 w-full px-4 lg:px-10">
          <div className="w-full text-center space-y-10">
            <div className="w-full flex justify-center">
              <div className="relative w-full mx-auto overflow-hidden rounded-[2.5rem] group">
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/10 to-transparent pointer-events-none" />
                <video
                  src={contactVideo}
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="block w-full h-full object-cover scale-100 lg:scale-[1.03] transition-transform duration-[5000ms] lg:group-hover:scale-[1.08]"
                />
              </div>
            </div>

            <div className="mt-8 flex justify-center">
              <img
                src={footerLogo}
                alt="Angelina Alriche"
                className="h-12 md:h-14 lg:h-16 object-contain"
              />
            </div>

            <div className="mt-10 px-4 lg:px-0">
              <nav className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 max-w-4xl mx-auto text-left md:text-center">
                <a
                  href="/#white-collection-title"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Белые костюмы' : 'White Suits'}
                </a>
                <a
                  href="/#purple-couture"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Сиреневые костюмы' : 'Lilac Suits'}
                </a>
                <a
                  href="/#black-Suits"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Черные костюмы' : 'Black Suits'}
                </a>
                <a
                  href="/#cocktail"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Коктейльные платья' : 'Cocktail Dresses'}
                </a>
                <a
                  href="/#red-collection"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {translations.featuredCollections.redCollectionTitle[language]}
                </a>
                <a
                  href="/#luxury-handmaker"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {translations.featuredCollections.luxuryHandmakerTitle[language]}
                </a>
                <a
                  href="/#black-and-white-collection"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {translations.featuredCollections.blackAndWhiteTitle[language]}
                </a>
                <a
                  href="/#collection-for-sale"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {translations.featuredCollections.collectionForSaleTitle[language]}
                </a>
                <a
                  href="/#wedding-dresses"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Свадебные платья' : 'Wedding Dresses'}
                </a>
                <a
                  href="/#jewellery-collection"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Ювелирная коллекция' : 'JEWELLERY COLLECTION'}
                </a>
              </nav>
              
              {/* Divider */}
              <div className="my-8 flex items-center justify-center">
                <div className="h-px bg-gradient-to-r from-transparent via-white/30 to-transparent w-full max-w-2xl"></div>
              </div>
              
              {/* Shop Links */}
              <nav className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5 max-w-4xl mx-auto text-left md:text-center">
                <a
                  href="/shop?category=Luxury"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  Luxury Collection
                </a>
                <a
                  href="/shop?category=Cocktail"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Коктейльные платья' : 'Cocktail Dresses'}
                </a>
                <a
                  href="/shop?category=Kids"
                  className="block text-sm md:text-base font-medium tracking-wide text-gray-200 hover:text-white transition-colors duration-300 montserrat"
                >
                  {language === 'ru' ? 'Коллекция для маленькой принцессы' : 'Collection for Little Princess'}
                </a>
              </nav>
            </div>

            <div className="mt-14 space-y-7 px-4 lg:px-0">
              <div className="text-base md:text-lg lg:text-xl uppercase tracking-[0.3em] text-white/70 text-center font-semibold">
                Contacts us
              </div>

              <div className="flex flex-wrap items-center justify-center gap-3">
                {/* Facebook */}
                <a
                  href="https://www.facebook.com/angelina.alriche.2025"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full border border-white/40 text-gray-200 hover:text-white hover:border-white transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-line text-[0.6rem] md:text-xs"></i>
                </a>
                {/* Instagram main */}
                <a
                  href="https://instagram.com/angelinaalriche"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full border border-white/40 text-gray-200 hover:text-white hover:border-white transition-colors cursor-pointer"
                >
                  <i className="ri-instagram-line text-[0.6rem] md:text-xs"></i>
                </a>
                {/* YouTube */}
                <a
                  href="https://youtube.com/@Richshel"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full border border-white/40 text-gray-200 hover:text-white hover:border-white transition-colors cursor-pointer"
                >
                  <i className="ri-youtube-line text-[0.6rem] md:text-xs"></i>
                </a>
                {/* Telegram */}
                <a
                  href="http://t.me/ALRICHE"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full border border-white/40 text-gray-200 hover:text-white hover:border-white transition-colors cursor-pointer"
                >
                  <i className="ri-telegram-line text-[0.6rem] md:text-xs"></i>
                </a>
                {/* WhatsApp */}
                <a
                  href="https://wa.me/34662975699"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-6 h-6 md:w-7 md:h-7 flex items-center justify-center rounded-full border border-white/40 text-gray-200 hover:text-white hover:border-white transition-colors cursor-pointer"
                >
                  <i className="ri-whatsapp-line text-[0.6rem] md:text-xs"></i>
                </a>
              </div>

              <div className="space-y-1 text-sm md:text-base montserrat text-left max-w-md mx-auto">
                <div>
                  mail: <span className="underline decoration-white/70">angelinaalriche@gmail.com</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

const DesignerText = ({ language }) => {
  const [expanded, setExpanded] = useState(false)

  const previewRu = <>Коллекция Анжелины Алричи «Инопланетяне с Марса» — это смелое художественное заявление, вдохновленное представлениями о внеземных цивилизациях и будущем человечества в эпоху освоения космоса. Проект посвящен загадочным обитателям планеты Марс и новаторским идеям предпринимателя и новатора Илона Маска.<br /><br />При создании этой коллекции Анжелина Алричи разработала каждый образ с нуля, уделяя исключительное внимание сложным конструкциям и мельчайшим деталям. Центральным элементом коллекции является серия уникальных головных масок, изготовленных по индивидуальному заказу и дополненных декоративными элементами для плеч, шеи и рук — оригинальными повязками, браслетами и нарукавниками, украшенными кристаллами Swarovski.</>

  const restRu = <><br /><br />В создании коллекции использовались только высококачественные натуральные материалы: 100% шелк высшего качества и различные виды натуральной кожи, от ультратонкой до богато текстурированной, включая эксклюзивные варианты с золотым, серебряным и переливающимся металлическим покрытием.<br /><br />Особое место в коллекции занимают роскошные плиссированные ткани, изготовленные на заказ на специализированных производственных предприятиях. Эти материалы украшены стразами, пайетками и кристаллами, создавая эффект космического мерцания и движения света.<br /><br />Некоторые маски были созданы с использованием передовых технологий по специальному заказу в лабораторных условиях и дополнительно декорированы кристаллами Swarovski. Их поверхности покрыты инновационной краской-хамелеоном, которая меняет цвет в зависимости от условий освещения и угла обзора. В отдельных элементах костюмов и аксессуаров используется микроэлектроника, позволяющая тканям и маскам трансформировать свои цветовые эффекты в реальном времени.<br /><br />Коллекция переносит зрителя в фантастический мир будущего, где мода становится языком общения между цивилизациями, а искусство сливается с наукой, технологией и мечтами человечества об освоении космоса. Каждый образ символизирует возможное появление разумных марсианских существ, сочетая футуризм, высокую моду и инновационный дизайн.<br /><br />«Инопланетяне с Марса» Анжелины Алричи — это не просто модная коллекция, а масштабный художественный проект, исследующий будущее, межпланетные путешествия и стремление человечества выйти за пределы известного мира. Это дань уважения эпохе великих космических открытий и людям, которые вдохновляют мир мечтать о достижении и исследовании других планет. 🚀✨</>

  const previewEn = <>Angelina Alriche's collection "Aliens from the Planet Mars" is a bold artistic statement inspired by notions of extraterrestrial civilizations and the future of humanity in the era of space exploration. The project is dedicated to the mysterious inhabitants of the planet Mars and the pioneering ideas of entrepreneur and innovator Elon Musk.<br /><br />When creating this collection, Angelina Alriche developed each look from scratch, paying exceptional attention to complex structures and the smallest details. The central element of the collection is a series of unique, custom-made head masks, complemented by decorative elements for the shoulders, neck, and arms — original bands, bracelets, and armlets adorned with Swarovski crystals.</>

  const restEn = <><br /><br />Only high-quality natural materials were used in the creation of the collection: 100% top-quality silk and various types of genuine leather, from ultra-thin to richly textured, including exclusive options with gold, silver, and iridescent metallic coatings.<br /><br />A special place in the collection is occupied by luxurious pleated fabrics, custom-made at specialized manufacturing facilities. These materials are decorated with rhinestones, sequins, and crystals, creating an effect of cosmic shimmer and the movement of light.<br /><br />Some masks were created using advanced technologies by special order in laboratory conditions and were additionally decorated with Swarovski crystals. Their surfaces are coated with an innovative chameleon paint that changes color depending on lighting conditions and the viewing angle. Microelectronics are used in individual elements of the costumes and accessories, allowing the fabrics and masks to transform their color effects in real time.<br /><br />The collection transports the viewer into a fantastic world of the future, where fashion becomes a language of communication between civilizations, and art merges with science, technology, and humanity's dreams of space exploration. Each look symbolizes the possible emergence of intelligent Martian beings, combining futurism, high fashion, and innovative design.<br /><br />"Aliens from the Planet Mars" by Angelina Alriche is not just a fashion collection, but a large-scale artistic project that explores the future, interplanetary travel, and humanity's desire to go beyond the boundaries of the known world. It is a tribute to the era of great space discoveries and to the people who inspire the world to dream of reaching and exploring other planets. 🚀✨</>

  return (
    <div className="text-white/90 montserrat text-sm md:text-[15px] leading-relaxed max-w-lg">
      <p>
        {language === 'ru' ? previewRu : previewEn}
        {expanded && (language === 'ru' ? restRu : restEn)}
      </p>
      <button
        onClick={() => setExpanded(!expanded)}
        className="mt-4 text-[#CEA15F] hover:text-[#B8914F] font-medium text-sm transition-colors duration-200 montserrat cursor-pointer"
      >
        {expanded
          ? (language === 'ru' ? 'Свернуть ↑' : 'Show less ↑')
          : (language === 'ru' ? 'Читать далее ↓' : 'Read more ↓')}
      </button>
    </div>
  )
}

export default Home
